import AdtConfig from '@/shared/advanced-data-table/model/AdtConfig';

export interface FilterConfigState {
  filterConfigs: { [configKey: string]: AdtConfig };
}

const state: FilterConfigState = {
  filterConfigs: {},
};

const mutations = {
  setFilterConfig(state: FilterConfigState, { configKey, config }: { configKey: string; config: AdtConfig }) {
    state.filterConfigs = {
      ...state.filterConfigs,
      [configKey]: config,
    };
  },
};

const actions = {
  loadFilterConfig({ commit }: any, configKey: string) {
    const configStr = localStorage.getItem(configKey);
    if (configStr) {
      const config = JSON.parse(configStr);
      commit('setFilterConfig', { configKey, config });
    }
  },
  saveFilterConfig({ commit }: any, { configKey, config }: { configKey: string; config: AdtConfig }) {
    localStorage.setItem(configKey, JSON.stringify(config));
    commit('setFilterConfig', { configKey, config });
  },
};

const getters = {
  getFilterConfig: (state: FilterConfigState) => (configKey: string): AdtConfig | null => {
    return state.filterConfigs[configKey] || null;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
